// 한글이 아닌 문자 정규표현식
export const NOT_KOREAN_REGEXR = /[a-z0-9]|[ [\]{}()<>?|`~!@#$%^&*-_+=,.;:"'\\]/g

// 숫자만 추출하는 정규표현식
export const ONLY_NUMBER_REGEXR = /\D/g
